var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _activeFetch, _CartDiscount_instances, recalcParentAccordion_fn, createAbortController_fn, handleDiscountError_fn, existingDiscounts_fn;
import { C as Component, j as fetchConfig, D as DiscountUpdateEvent, m as morphSection } from "./utilities-Da0sjanJ.js";
class CartDiscount extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartDiscount_instances);
    __publicField(this, "requiredRefs", ["cartDiscountError", "cartDiscountErrorDiscountCode", "cartDiscountErrorShipping"]);
    __privateAdd(this, _activeFetch, null);
    __publicField(this, "applyDiscount", async (event) => {
      const { cartDiscountError, cartDiscountErrorDiscountCode, cartDiscountErrorShipping, button } = this.refs;
      event.preventDefault();
      event.stopPropagation();
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const discountCode = form.querySelector('input[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== "string" || discountCode.value == "") return;
      const discountCodeValue = discountCode.value;
      const abortController = __privateMethod(this, _CartDiscount_instances, createAbortController_fn).call(this);
      button.setAttribute("loading", "");
      try {
        const existingDiscounts = __privateMethod(this, _CartDiscount_instances, existingDiscounts_fn).call(this);
        if (existingDiscounts.includes(discountCodeValue)) return;
        cartDiscountError.classList.add("hidden");
        cartDiscountErrorDiscountCode.classList.add("hidden");
        cartDiscountErrorShipping.classList.add("hidden");
        const config = fetchConfig("json", {
          body: JSON.stringify({
            discount: [...existingDiscounts, discountCodeValue].join(","),
            sections: [this.dataset.sectionId]
          })
        });
        const response = await fetch(Theme.routes.cart_update_url, {
          ...config,
          signal: abortController.signal
        });
        const data = await response.json();
        if (data.discount_codes.find((discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })) {
          discountCode.value = "";
          __privateMethod(this, _CartDiscount_instances, handleDiscountError_fn).call(this, "discount_code");
          return;
        }
        const newHtml = data.sections[this.dataset.sectionId];
        const parsedHtml = new DOMParser().parseFromString(newHtml, "text/html");
        const section = parsedHtml.getElementById(`shopify-section-${this.dataset.sectionId}`);
        const discountCodes = (section == null ? void 0 : section.querySelectorAll(".cart-discount__pill")) || [];
        if (section) {
          const codes = Array.from(discountCodes).map((element) => element instanceof HTMLLIElement ? element.dataset.discountCode : null).filter(Boolean);
          if (codes.length === existingDiscounts.length && codes.every((code) => existingDiscounts.includes(code)) && data.discount_codes.find((discount) => {
            return discount.code === discountCodeValue && discount.applicable === true;
          })) {
            __privateMethod(this, _CartDiscount_instances, handleDiscountError_fn).call(this, "shipping");
            discountCode.value = "";
            return;
          }
        }
        document.dispatchEvent(new DiscountUpdateEvent(data, this.id));
        morphSection(this.dataset.sectionId, newHtml);
        __privateMethod(this, _CartDiscount_instances, recalcParentAccordion_fn).call(this);
      } catch (error) {
      } finally {
        __privateSet(this, _activeFetch, null);
        button.removeAttribute("loading", "");
      }
    });
    __publicField(this, "removeDiscount", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (event instanceof KeyboardEvent && event.key !== "Enter" || !(event instanceof MouseEvent) || !(event.target instanceof HTMLElement) || typeof this.dataset.sectionId !== "string") {
        return;
      }
      const pill = event.target.closest(".cart-discount__pill");
      if (!(pill instanceof HTMLLIElement)) return;
      const discountCode = pill.dataset.discountCode;
      if (!discountCode) return;
      const existingDiscounts = __privateMethod(this, _CartDiscount_instances, existingDiscounts_fn).call(this);
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;
      existingDiscounts.splice(index, 1);
      const abortController = __privateMethod(this, _CartDiscount_instances, createAbortController_fn).call(this);
      try {
        const config = fetchConfig("json", {
          body: JSON.stringify({ discount: existingDiscounts.join(","), sections: [this.dataset.sectionId] })
        });
        const response = await fetch(Theme.routes.cart_update_url, {
          ...config,
          signal: abortController.signal
        });
        const data = await response.json();
        document.dispatchEvent(new DiscountUpdateEvent(data, this.id));
        morphSection(this.dataset.sectionId, data.sections[this.dataset.sectionId]);
        __privateMethod(this, _CartDiscount_instances, recalcParentAccordion_fn).call(this);
      } catch (error) {
      } finally {
        __privateSet(this, _activeFetch, null);
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
  }
}
_activeFetch = new WeakMap();
_CartDiscount_instances = new WeakSet();
/**
 * After morphSection updates the inner HTML, the parent accordion-component
 * may still hold a stale maxHeight / overflow on its content panel.
 * Reset them so the accordion adapts to the new content size.
 */
recalcParentAccordion_fn = function() {
  const accordion = this.closest("accordion-component");
  if (!accordion) return;
  const contentEl = accordion.contentEl;
  if (!contentEl) return;
  contentEl.style.maxHeight = "none";
  contentEl.style.overflow = "visible";
};
createAbortController_fn = function() {
  if (__privateGet(this, _activeFetch)) {
    __privateGet(this, _activeFetch).abort();
  }
  const abortController = new AbortController();
  __privateSet(this, _activeFetch, abortController);
  return abortController;
};
handleDiscountError_fn = function(type) {
  const { cartDiscountError, cartDiscountErrorDiscountCode, cartDiscountErrorShipping } = this.refs;
  const target = type === "discount_code" ? cartDiscountErrorDiscountCode : cartDiscountErrorShipping;
  cartDiscountError.classList.remove("hidden");
  target.classList.remove("hidden");
};
existingDiscounts_fn = function() {
  const discountCodes = [];
  const discountPills = this.querySelectorAll(".cart-discount__pill");
  for (const pill of discountPills) {
    if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === "string") {
      discountCodes.push(pill.dataset.discountCode);
    }
  }
  return discountCodes;
};
if (!customElements.get("cart-discount")) {
  customElements.define("cart-discount", CartDiscount);
}
